export const formatBytesPerSecond = (bytes: number) => {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  let unitIndex = 0;
  let displayValue = bytes;
  while (displayValue >= 1024 && unitIndex < units.length - 1) {
    displayValue /= 1024;
    unitIndex++;
  }
  return displayValue.toLocaleString(undefined, { maximumFractionDigits: 2 }) + ' ' + units[unitIndex] + '/s';
};
